import { useState } from 'react';
import { supabase } from '../supabase';
import '../styles/Login.css';

export default function Login() {
  const [loading, setLoading] = useState(false);
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const [loginMethod, setLoginMethod] = useState('password'); // 'password' or 'magic'
  const [message, setMessage] = useState({ type: '', text: '' });

  const handlePasswordLogin = async (e) => {
    e.preventDefault();
    setMessage({ type: '', text: '' });

    try {
      setLoading(true);
      const { error } = await supabase.auth.signInWithPassword({ 
        email, 
        password 
      });
      if (error) throw error;
    } catch (error) {
      setMessage({ 
        type: 'error', 
        text: error.error_description || error.message 
      });
    } finally {
      setLoading(false);
    }
  };

  const handleMagicLink = async (e) => {
    e.preventDefault();
    setMessage({ type: '', text: '' });

    try {
      setLoading(true);
      const { error } = await supabase.auth.signInWithOtp({ 
        email,
        options: {
          emailRedirectTo: `${window.location.origin}/dashboard`
        }
      });
      if (error) throw error;
      setMessage({ 
        type: 'success', 
        text: 'Check your email for the login link!' 
      });
    } catch (error) {
      setMessage({ 
        type: 'error', 
        text: error.error_description || error.message 
      });
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="login-container">
      <div className="login-card">
        <div className="login-header">
          <h1 className="login-title">KVM & Co.</h1>
          <p className="login-subtitle">FFA Tracker</p>
        </div>
        
        <div className="login-tabs">
          <button 
            className={`login-tab ${loginMethod === 'password' ? 'active' : ''}`}
            onClick={() => setLoginMethod('password')}
            type="button"
          >
            Email & Password
          </button>
          <button 
            className={`login-tab ${loginMethod === 'magic' ? 'active' : ''}`}
            onClick={() => setLoginMethod('magic')}
            type="button"
          >
            Magic Link
          </button>
        </div>

        {message.text && (
          <div className={`login-message ${message.type}`}>
            {message.text}
          </div>
        )}

        {loginMethod === 'password' ? (
          <form onSubmit={handlePasswordLogin} className="login-form">
            <div className="form-group">
              <label htmlFor="email">Email</label>
              <input
                id="email"
                type="email"
                placeholder="Enter your email"
                value={email}
                onChange={(e) => setEmail(e.target.value)}
                className="form-input"
                required
              />
            </div>
            <div className="form-group">
              <label htmlFor="password">Password</label>
              <input
                id="password"
                type="password"
                placeholder="Enter your password"
                value={password}
                onChange={(e) => setPassword(e.target.value)}
                className="form-input"
                required
              />
            </div>
            <button className="login-button" disabled={loading}>
              {loading ? (
                <span className="loader"></span>
              ) : (
                'Sign In'
              )}
            </button>
          </form>
        ) : (
          <form onSubmit={handleMagicLink} className="login-form">
            <div className="form-group">
              <label htmlFor="magic-email">Email</label>
              <input
                id="magic-email"
                type="email"
                placeholder="Enter your email"
                value={email}
                onChange={(e) => setEmail(e.target.value)}
                className="form-input"
                required
              />
            </div>
            <button className="login-button" disabled={loading}>
              {loading ? (
                <span className="loader"></span>
              ) : (
                'Send Magic Link'
              )}
            </button>
          </form>
        )}
        
        <p className="login-footer">
          Contact administrator for account access
        </p>
      </div>
    </div>
  );
}